import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'reactstrap';
import { useIntl } from 'react-intl';
import classnames from 'classnames';

import EmptyStateVideo from './components/Video';
import UnlockButton from './components/UnlockButton';
import LearnMoreLink from './components/LearnMoreLink';

import { userHasFeature } from '../../helpers/Features';

const EmptyFileSizes = ({ handleNewItem, padded }) => {
  const intl = useIntl();

  return (
    <div className={classnames('empty-state-wrapper row align-items-center justify-content-center', { 'empty-state-wrapper-padded': padded })}>
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'On-demand file resizing' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({
            defaultMessage: 'Create custom image download sizes so your team can grab the right dimensions for any project.',
          })}
        </div>
        {userHasFeature('file-sizes') ? (
          <Button color="primary" className="mt-4" onClick={handleNewItem}>
            {intl.formatMessage({ defaultMessage: 'Create a file size' })}
          </Button>
        ) : (
          <UnlockButton feature="file-sizes" />
        )}
        <LearnMoreLink url="https://help.stockpress.co/en/articles/5937873-add-multiple-file-sizes-for-downloads" />
      </Col>
      <EmptyStateVideo video="file-sizes" />
    </div>
  );
};

EmptyFileSizes.propTypes = {
  handleNewItem: PropTypes.func,
  padded: PropTypes.bool,
};

EmptyFileSizes.defaultProps = {
  handleNewItem: () => { },
  padded: false,
};

export default EmptyFileSizes;
